import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function Layout({ children, transparentOnHero = false }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar transparentOnHero={transparentOnHero} />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
